// select-mapping-dialog.component.ts
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SelectMappingDialogData {
    message: string;
    options: { label: string; value: 'balance' | 'income' }[];
}

@Component({
    selector: 'app-select-mapping-dialog',
    styleUrls: ['select-mapping-dialog.scss'],
    template: `
        <h1>{{ data.message }}</h1>
        <div>
            <ham-button
                *ngFor="let option of data.options"
                (buttonClick)="selectOption(option.value)"
                style="cursor: pointer"
            >
                {{ option.label }}
            </ham-button>
        </div>
    `,
})
export class SelectMappingDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<SelectMappingDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: SelectMappingDialogData,
    ) {}

    selectOption(value: 'balance' | 'income'): void {
        this.dialogRef.close(value);
    }

    cancel(): void {
        this.dialogRef.close();
    }
}
